module.exports = "/_next/static/images/browse-90cff973d30a6cdbba5445bbce399dd2.svg";